import { Data } from "dataclass";
import { TripDto } from "../../../../Global/models/TripDto";

export class QuickDetailsViewModel extends Data {
  inclusions: string[] = [];
  exclusions: string[] = [];
  quickDetails: Details[] = [];
}

export class Details extends Data {
  image: string = "";
  title: string = "";
  description: string = "";
}

export const mapToQuickDetailsViewModel = (
  tripDto: TripDto
): QuickDetailsViewModel => {
  return QuickDetailsViewModel.create({
    inclusions: tripDto.inclusions || [],
    exclusions: tripDto.exclusions || [],
    quickDetails: tripDto.quickDetails.map((quickDetail) =>
      Details.create({
        image: quickDetail.itemImg,
        title: quickDetail.itemTitle,
        description: quickDetail.itemDesc,
      })
    ),
  });
};
